import { ON_SAVE_PROFILE_UNITS } from "../actions/ProfileUnits";

const KEY_NAME = "profileUnits";

const getStorage = (key) => {
  let storage = sessionStorage.getItem(key);

  return storage !== null ? JSON.parse(storage) : null;
};

const setLocalStorage = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value));
};

let profileUnits = getStorage(KEY_NAME) ? getStorage(KEY_NAME) : [];

const initialState = {
  profileUnits,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ON_SAVE_PROFILE_UNITS:
      setLocalStorage(KEY_NAME, action.payload);
      return {
        ...state,
        profileUnits: [...action.payload],
      };
    default:
      return state;
  }
};
export default reducer;
